import React from 'react'
import * as Styled from './Flyouts.styles'

export const paymentPlanFlyout = (termsAndConditions) => {
  const { text } = termsAndConditions
  return (
    <Styled.Flyout data-test='m023-paymentPlan-termsAndConditions'>
      <Styled.FlyoutText dangerouslySetInnerHTML={{ __html: text }} />
    </Styled.Flyout>
  )
}
